var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.chartData.length)?_c('div',{staticClass:"chart-wrapper"},[_c(_setup.MobileLineBar,{attrs:{"chartOptions":{
			grid: { top: 16 },
			legend: { show: false }
		},"timeFormatter":_setup.timeFormatter,"seriesData":_setup.chartData,"tooltip-label":_vm.$t('enterprise.total-of-holdings'),"legends":[_vm.$t('enterprise.total-of-holdings')]}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }